import { render, staticRenderFns } from "./AlarmQueueCCure.vue?vue&type=template&id=c2e265e4&scoped=true"
import script from "./AlarmQueueCCure.vue?vue&type=script&lang=ts"
export * from "./AlarmQueueCCure.vue?vue&type=script&lang=ts"
import style0 from "./AlarmQueueCCure.vue?vue&type=style&index=0&id=c2e265e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2e265e4",
  null
  
)

export default component.exports